export class StudyComments {
  commentId: number;
  referenceId: number;
  comparableId?: number;
  sectionType: number;
  comments: string;
  isActive: boolean;
  createdBy: number;
  createdOn: Date;
  userName: string;
}
